export interface AddressBook {
  name: string;
  address: string;
  coin_network?: string;
  network_name?: string;
  paymentId?: string;
  trusted: boolean;
  status: number;
  statusLabel: string;
  beneficiary?: string;
  destination?: string;
}

export interface ModifyAddressBook {
  code: string;
  name: string;
  address: string;
  coin_network?: string;
  network_name?: string;
  action: string;
  paymentId?: string;
  trusted?: boolean;
  password?: string;
  tfa?: string;
  fundPin?: string;
  beneficiary?: string;
  destination?: string;
}

export interface AddressBookConfirm {
  hash: string;
  action: string;
}

export interface UnsavedAddresses {
  code: string;
  coin_network?: string;
  network_name?: string;
  lastWithdrawal: string;
  address: string;
  paymentId?: string;
  beneficiary?: string;
  destination?: string;
}

export enum AddressStatus {
  Untrusted = 0,
  Trusted = 2,
  Pending = 1
}

export enum DestinationType {
  PRIVATE = 'private',
  EXCHANGE = 'exchange'
}

export enum AddressBookAction {
  ADD = 'add',
  EDIT = 'edit'
}

export enum PrivateWalletDisplayName {
  PRIVATE_WALLET = 'Self Custody Wallet'
}

export enum AddressBookFormInputs {
  DESTINATION = 'destination',
  DESTINATION_TYPE = 'destination_type',
  EXCHANGE_NAME = 'exchange_name',
}

export enum DestinationControlInput {
  OTHER = 'Other',
}

export enum CoinNetworkStatus {
  ACTIVE = '1',
  NOT_ACTIVE = '0'
}
